import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="application--redirect"
export default class extends Controller {
  static values = {
    location: String,
    action: String
  }

  connect() {
    Turbo.visit(this.locationValue, { action: this.actionValue })
  }
}
